<template>
  <div>
    <!-- title -->
    <single-report-header :title="report.getTitle()" :date="date" />
    <v-row
      v-if="bookingEntryFilterable.getBookingEntries(true).length"
      class="content-5"
    >
      <v-col class="col-12 pt-0">
        <!-- header -->
        <v-row class="font-weight-black avoid-inside-break">
          <!-- room number -->
          <v-col class="col-1">
            {{ $t('singleReport.roomNumber') }}
          </v-col>

          <!-- product definition -->
          <v-col class="col-2">
            {{ $t('singleReport.details') }}
          </v-col>

          <!-- user name -->
          <v-col class="col-2">
            {{ $t('shopBackendBookingOverview.customer') }}
          </v-col>

          <!-- address -->
          <v-col class="col-1">
            {{ $t('general.address') }}
          </v-col>

          <!-- mail -->
          <v-col class="col-2">
            {{ $t('general.email') }}
          </v-col>

          <!-- phone -->
          <v-col class="col-1">
            {{ $t('singleReport.tel') }}
          </v-col>

          <!-- note -->
          <v-col class="col-3">
            {{ $t('extraRides.comment') }}
          </v-col>
        </v-row>

        <!-- iterate booking entries -->
        <v-row
          v-for="(
            bookingEntry, bookingEntryIndex
          ) in bookingEntriesSortedByAllocationNumber"
          :key="bookingEntryIndex"
          class="avoid-inside-break border-top"
          :variable="(buyer = bookingEntry.getBooking().getBuyer())"
        >
          <!-- room number -->
          <v-col class="col-1 pa-1">
            {{ bookingEntry.getAllocationNumber() }}
          </v-col>

          <!-- product definition -->
          <v-col class="col-2 pa-1">
            {{ bookingEntry.getProductDefinitionTranslation() }}
          </v-col>

          <!-- user name -->
          <v-col class="col-2 pa-1">
            <p v-if="buyer.getCompany()" class="my-0">
              {{ buyer.getCompany() }}
            </p>
            {{ buyer.getFullName() }}
          </v-col>

          <!-- address -->
          <v-col class="col-1 pa-1" style="word-break: break-all">
            {{ buyer.getZip() }} {{ buyer.getCity() }}
          </v-col>

          <!-- mail -->
          <v-col class="col-2 pa-1" style="word-break: break-all">
            {{ buyer.getMail() }}
          </v-col>

          <!-- phone -->
          <v-col class="col-1 pa-1">
            {{ buyer.getPhone() }}
          </v-col>

          <!-- note -->
          <v-col class="col-3 pa-1">
            {{ bookingEntry.getBooking().getNote() }}
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <!-- no booking entries -->
    <v-row v-else>
      <v-col class="col-12 content-2">
        <span class="fal fa-folder-open mr-2" />
        {{ $t('singleReport.noContent') }}
      </v-col>
    </v-row>
  </div>
</template>

<script>
import ReportMixin from '../ReportMixin'
import SingleReportHeader from '../SingleReportHeader'
import _ from 'lodash'

export default {
  name: 'ReportNiesenHotel',
  components: { SingleReportHeader },
  mixins: [ReportMixin],

  computed: {
    bookingEntriesSortedByAllocationNumber() {
      if (this.bookingEntryFilterable.getBookingEntries(true).length) {
        return _.sortBy(
          this.bookingEntryFilterable.getBookingEntries(true),
          (entry) => entry.getAllocationNumber()
        )
      }
      return []
    },
  },

  mounted() {
    // via mixin
    this.loadBookingEntriesFilterable(10001)
  },
}
</script>
